
import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Unpacked } from '../../../../react-app-env';

const _selectEmergencyRoleInitQuery = (id: string) => ({
  emergency_roles_by_pk: params(
    { id: rawString(id) },
    {
      name: types.string,
    }
  ),
});

type X = Unpacked<typeof _selectEmergencyRoleInitQuery>
export type EmergencyRole = X['emergency_roles_by_pk'];

export const selectEmergencyRoleInitQuery = (id: string) => gql`${query(_selectEmergencyRoleInitQuery(id))}`;
